// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  margin-right: 2%;
  min-width: 15%;
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,cAAA;AACJ","sourcesContent":["button {\n    margin-right: 2%;\n    min-width: 15%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
